export default "__VITE_ASSET__CunJbSJw__"